import React from 'react'

const Skipped = ({ title, content, className = "" }) => {
    return (
        <div
            className={`flex flex-col items-center justify-center 
                p-6 rounded-xl border border-yellow-300 bg-yellow-50 
                text-yellow-700 shadow-sm ${className}`}
        >
            <div className="flex items-center gap-2 mb-1">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-yellow-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 5a7 7 0 100 14 7 7 0 000-14z" />
                </svg>

                <span className="text-lg font-semibold">
                    {title || "Skipped"}
                </span>
            </div>

            {content && (
                <p className="text-sm text-yellow-700 opacity-80 text-center">
                    {content}
                </p>
            )}
        </div>
    )
}

export default Skipped
